"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _icons = require("@material-ui/icons");
var _contexts = require("../../contexts");
var _lemeIcon = _interopRequireDefault(require("../../assets/leme-icon.svg"));
var _StylesPopover = _interopRequireDefault(require("../PopoverWrapper/StylesPopover"));
var _ReferencesPopover = _interopRequireDefault(require("../PopoverWrapper/ReferencesPopover"));
var _styles = _interopRequireDefault(require("./styles"));
var _services = require("../../services");
var _utils = require("../../utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } /* eslint-disable react/jsx-no-bind */ // Contexts
// Assets
// Components
// Styles
// Utils
var TOOLTIP_OFFLINE_MESSAGE = 'Fique online para acessar as funções da biblioteca digital saraiva';
function SideBar() {
  var {
    sessionToken,
    backToBds
  } = (0, _react.useContext)(_contexts.EpubReaderContext);
  var appToken = (0, _utils.appTokenCase)(window.location.origin);
  var trackService = (0, _services.TrackingsService)(appToken, sessionToken);
  var classes = (0, _styles.default)();
  var {
    isPageBookmarked
  } = (0, _react.useContext)(_contexts.BookmarksContext);
  var {
    backgroundStyle
  } = (0, _react.useContext)(_contexts.ReaderPreferencesContext);
  var {
    handleDrawerActions,
    showingTooltip,
    setShowingTooltip
  } = (0, _react.useContext)(_contexts.SideBarContext);
  var {
    isAppOffline,
    uuid,
    loadingLocations,
    bookTitle
  } = (0, _react.useContext)(_contexts.EpubReaderContext);
  return /*#__PURE__*/_react.default.createElement(_core.AppBar, {
    position: "fixed",
    className: classes.appBar,
    style: {
      backgroundColor: (0, _utils.handleBackGroundStyle)(backgroundStyle)
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Toolbar, {
    className: classes.toolbar
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    color: "primary",
    className: classes.backButton,
    style: {
      color: (0, _utils.handleTextColor)(backgroundStyle)
    },
    startIcon: /*#__PURE__*/_react.default.createElement(_icons.ArrowBackIos, {
      style: {
        color: (0, _utils.handleTextColor)(backgroundStyle)
      }
    }),
    onClick: /*#__PURE__*/_asyncToGenerator(function* () {
      if ((0, _utils.getIntegrationType)() === 'marc_integration') {
        localStorage.setItem('lastAccessFromEpubReader', true);
        window.location.assign("/books/".concat(uuid));
      } else {
        yield trackService.trackBackPage({
          uuid,
          bookTitle
        });
        backToBds();
      }
    })
  }, "Voltar"), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.logo
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _lemeIcon.default,
    alt: "Leme",
    className: classes.logo
  })), /*#__PURE__*/_react.default.createElement(_core.BottomNavigation, {
    showLabels: true,
    classes: {
      root: classes.toolbarNavigationContainer
    },
    style: {
      backgroundColor: (0, _utils.handleBackGroundStyle)(backgroundStyle)
    },
    onChange: (event, newValue) => {
      if (isAppOffline) {
        return;
      }
      handleDrawerActions(event, newValue);
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    open: showingTooltip === 'summaryNavigation' && isAppOffline,
    onOpen: () => setShowingTooltip('summaryNavigation'),
    onClose: () => setShowingTooltip(null),
    title: TOOLTIP_OFFLINE_MESSAGE,
    placement: "right",
    arrow: true,
    classes: {
      tooltip: classes.tooltip
    }
  }, /*#__PURE__*/_react.default.createElement(_core.BottomNavigationAction, {
    label: "Menu",
    style: {
      color: (0, _utils.handleTextColor)(backgroundStyle),
      backgroundColor: (0, _utils.handleBackGroundStyle)(backgroundStyle)
    },
    icon: /*#__PURE__*/_react.default.createElement(_icons.FormatListBulleted, {
      style: {
        color: (0, _utils.handleTextColor)(backgroundStyle)
      }
    }),
    value: "summary",
    classes: {
      root: isAppOffline ? classes.tollbarNavigationDisabled : classes.toolbarNavigation,
      selected: classes.toolbarNavigationSelected
    },
    disabled: loadingLocations
  })), /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    open: showingTooltip === 'searchNavigation' && isAppOffline,
    onOpen: () => setShowingTooltip('searchNavigation'),
    onClose: () => setShowingTooltip(null),
    title: TOOLTIP_OFFLINE_MESSAGE,
    placement: "right",
    arrow: true,
    classes: {
      tooltip: classes.tooltip
    }
  }, /*#__PURE__*/_react.default.createElement(_core.BottomNavigationAction, {
    label: "Buscar",
    style: {
      color: (0, _utils.handleTextColor)(backgroundStyle),
      backgroundColor: (0, _utils.handleBackGroundStyle)(backgroundStyle)
    },
    icon: /*#__PURE__*/_react.default.createElement(_icons.Search, {
      style: {
        color: (0, _utils.handleTextColor)(backgroundStyle)
      }
    }),
    value: "search",
    classes: {
      root: isAppOffline ? classes.tollbarNavigationDisabled : classes.toolbarNavigation,
      selected: classes.toolbarNavigationSelected
    },
    disabled: loadingLocations
  })), /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    open: showingTooltip === 'bookmarkNavigation' && isAppOffline,
    onOpen: () => setShowingTooltip('bookmarkNavigation'),
    onClose: () => setShowingTooltip(null),
    title: TOOLTIP_OFFLINE_MESSAGE,
    placement: "right",
    arrow: true,
    classes: {
      tooltip: classes.tooltip
    }
  }, /*#__PURE__*/_react.default.createElement(_core.BottomNavigationAction, {
    label: isPageBookmarked ? 'Página marcada' : 'Marcar página',
    style: {
      color: (0, _utils.handleTextColor)(backgroundStyle),
      backgroundColor: (0, _utils.handleBackGroundStyle)(backgroundStyle)
    },
    icon: isPageBookmarked ? /*#__PURE__*/_react.default.createElement(_icons.Bookmark, {
      style: {
        color: (0, _utils.handleTextColor)(backgroundStyle)
      }
    }) : /*#__PURE__*/_react.default.createElement(_icons.BookmarkBorder, {
      style: {
        color: (0, _utils.handleTextColor)(backgroundStyle)
      }
    }),
    value: "toggleBookmark",
    classes: {
      root: isAppOffline ? classes.tollbarNavigationDisabled : classes.toolbarNavigation,
      selected: classes.toolbarNavigationSelected
    },
    disabled: loadingLocations
  })), /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    open: showingTooltip === 'styleNavigation' && isAppOffline,
    onOpen: () => setShowingTooltip('styleNavigation'),
    onClose: () => setShowingTooltip(null),
    title: TOOLTIP_OFFLINE_MESSAGE,
    placement: "right",
    arrow: true,
    classes: {
      tooltip: classes.tooltip
    }
  }, /*#__PURE__*/_react.default.createElement(_core.BottomNavigationAction, {
    label: "Estilo",
    value: "formatting",
    style: {
      color: (0, _utils.handleTextColor)(backgroundStyle),
      backgroundColor: (0, _utils.handleBackGroundStyle)(backgroundStyle)
    },
    icon: /*#__PURE__*/_react.default.createElement(_icons.FormatSize, {
      style: {
        color: (0, _utils.handleTextColor)(backgroundStyle)
      }
    }),
    classes: {
      root: isAppOffline ? classes.tollbarNavigationDisabled : classes.toolbarNavigation,
      selected: classes.toolbarNavigationSelected
    },
    disabled: loadingLocations
  })), /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    open: showingTooltip === 'referenceNavigation' && isAppOffline,
    onOpen: () => setShowingTooltip('referenceNavigation'),
    onClose: () => setShowingTooltip(null),
    title: TOOLTIP_OFFLINE_MESSAGE,
    placement: "right",
    arrow: true,
    classes: {
      tooltip: classes.tooltip
    }
  }, /*#__PURE__*/_react.default.createElement(_core.BottomNavigationAction, {
    label: "Refer\xEAncia",
    value: "references",
    style: {
      color: (0, _utils.handleTextColor)(backgroundStyle),
      backgroundColor: (0, _utils.handleBackGroundStyle)(backgroundStyle)
    },
    icon: /*#__PURE__*/_react.default.createElement(_icons.FormatQuote, {
      style: {
        color: (0, _utils.handleTextColor)(backgroundStyle)
      }
    }),
    classes: {
      root: isAppOffline ? classes.tollbarNavigationDisabled : classes.toolbarNavigation,
      selected: classes.toolbarNavigationSelected
    },
    disabled: loadingLocations
  })), /*#__PURE__*/_react.default.createElement(_StylesPopover.default, null), /*#__PURE__*/_react.default.createElement(_ReferencesPopover.default, null))));
}
var _default = exports.default = SideBar;